// Curated content for the Nayara Studio marketing site.
// Nayara Studio = premium PRINTED-FABRIC & custom digital textile manufacturer
// (fashion fabrics, kurti fabrics, dress materials, event fabrics + photography/wedding/stage backdrops).
// Products will sync from ERP Product Master later (GET /api/public/products).

const px = (u) => (u.includes("?") ? u : `${u}?auto=compress&cs=tinysrgb&w=1600`);

export const IMG = {
  // Fashion & editorial
  hero: px("https://images.unsplash.com/photo-1758749646094-606f23edaef6"),
  fashionGreen: px("https://images.unsplash.com/photo-1779401810766-fc75ff0bdc52"),
  fashionWhite: px("https://images.unsplash.com/photo-1767972464165-d93f2eef1e4a"),
  fashionSheer: px("https://images.unsplash.com/photo-1770199105820-2e12ecee91a1"),
  // Printed dress fabrics
  printedRack: px("https://images.unsplash.com/photo-1775740396878-ec9179692921"),
  printedFolds: px("https://images.unsplash.com/photo-1584887585552-f494a4421f89"),
  printedStack: px("https://images.unsplash.com/photo-1507434745378-235a6297156b"),
  printedScarves: px("https://images.unsplash.com/photo-1711644620740-99a99b6568ef"),
  // Kurti / ethnic wear
  kurtiMaroon: px("https://images.unsplash.com/photo-1708534246055-d7b149acb731"),
  kurtiGreen: px("https://images.unsplash.com/photo-1597983073750-16f5ded1321f"),
  kurtiRedStreet: px("https://images.pexels.com/photos/35521738/pexels-photo-35521738.jpeg"),
  kurtiRedGarden: px("https://images.pexels.com/photos/37523792/pexels-photo-37523792.jpeg"),
  // Events & stage
  eventStageGold: px("https://images.unsplash.com/photo-1557136743-49acf41a781c"),
  eventBlueStage: px("https://images.unsplash.com/photo-1568989357443-057c03fb10fc"),
  eventGala: px("https://images.unsplash.com/photo-1598993947191-58e49166849e"),
  eventTable: px("https://images.unsplash.com/photo-1653821355736-0c2598d0a63e"),
  // Weddings
  weddingArch: px("https://images.pexels.com/photos/13156145/pexels-photo-13156145.jpeg"),
  weddingCandles: px("https://images.unsplash.com/photo-1746044159277-ced38bb9ae58"),
  weddingChandelier: px("https://images.unsplash.com/photo-1746739802678-93c777b6dfe6"),
  // Photography backdrops
  studioBlack: px("https://images.unsplash.com/photo-1634148739677-a5bb54df2611"),
  studioPink: px("https://images.unsplash.com/photo-1647427854253-b92bb40c9330"),
  studioLights: px("https://images.unsplash.com/photo-1648740678671-c37d78567ea8"),
  // Manufacturing
  printMachine: px("https://images.unsplash.com/photo-1693031630369-bd429a57f115"),
  printMachine2: px("https://images.unsplash.com/photo-1503694978374-8a2fa686963a"),
  showroom: px("https://images.unsplash.com/photo-1762803841262-99261e8ff08a"),
};

export const CONTACT = {
  brand: "Nayara Studio",
  tagline: "Premium Printed Fabrics & Custom Digital Textile Manufacturing",
  phone: "+91 95978 88978",
  whatsapp: "919597888978",
  email: "hello@nayarastudio.in",
  address: "Nayara Studio, Kumar Nagar, Tiruppur, Tamil Nadu, India",
  shortAddress: "Kumar Nagar, Tiruppur, Tamil Nadu",
  serviceArea: "Supplying premium printed fabrics, event fabrics & photography backdrops across India.",
  mapQuery: "Kumar Nagar, Tiruppur, Tamil Nadu",
  instagram: "https://instagram.com/nayarastudio",
  facebook: "https://facebook.com/nayarastudio",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Collections", to: "/collections" },
  { label: "Manufacturing", to: "/manufacturing" },
  { label: "About", to: "/about" },
  // { label: "Gallery", to: "/gallery" },  // hidden for now
  { label: "Contact", to: "/contact" },
];

export const COLLECTIONS = [
  { slug: "fashion-fabrics", name: "Fashion Fabrics", image: IMG.fashionSheer,
    tagline: "Designer prints for the modern wardrobe.",
    description: "Fashion-forward printed chiffons, georgettes and crepes — vivid, drapey and runway-ready for designers and boutiques." },
  { slug: "kurti-fabrics", name: "Kurti Fabrics", image: IMG.kurtiRedStreet,
    tagline: "Everyday elegance, printed to perfection.",
    description: "Soft, breathable printed fabrics tailored for kurtis — from delicate florals to bold ethnic motifs." },
  { slug: "dress-materials", name: "Dress Materials", image: IMG.printedFolds,
    tagline: "Ready-to-stitch, unstitched brilliance.",
    description: "Coordinated unstitched dress-material sets with true-to-artwork colour, ready for the tailor's table." },
  { slug: "event-fabrics", name: "Event Fabrics", image: IMG.eventGala,
    tagline: "Fabrics that set the scene.",
    description: "Large-format printed drapes and panels that transform banquets, galas and celebrations." },
  { slug: "photography-backdrops", name: "Photography Backdrops", image: IMG.studioBlack,
    tagline: "Studio-grade cloths for timeless frames.",
    description: "Printed and hand-finished backdrops engineered for photographers who obsess over light and tone." },
  { slug: "wedding-backdrops", name: "Wedding Backdrops", image: IMG.weddingArch,
    tagline: "Heirloom-worthy décor for the big day.",
    description: "Bespoke mandap drapes, floral panels and ceremonial backdrops crafted for celebration." },
  { slug: "stage-backdrops", name: "Stage Backdrops", image: IMG.eventStageGold,
    tagline: "Command the stage with seamless print.",
    description: "Seamless tension-fabric stage backdrops for concerts, corporate stages and productions." },
  { slug: "custom-printing", name: "Custom Printing", image: IMG.printMachine,
    tagline: "Your artwork, precisely rendered.",
    description: "End-to-end custom digital textile printing — from your design to finished, stitched textiles." },
];

export const PRODUCTS = [
  { id: "rose-bloom-chiffon", name: "Rose Bloom Printed Chiffon", collection: "Fashion Fabrics",
    images: [IMG.printedFolds, IMG.fashionGreen, IMG.printedRack], material: "Printed chiffon",
    finish: "Soft, fluid drape", from: "₹280 / m", sizes: ["Per metre", "44in / 58in width"],
    description: "A floaty, saturated floral chiffon built for statement dresses, dupattas and layered silhouettes." },
  { id: "midnight-georgette", name: "Midnight Georgette", collection: "Fashion Fabrics",
    images: [IMG.fashionSheer, IMG.fashionWhite, IMG.printedRack], material: "Printed georgette",
    finish: "Matte, elegant fall", from: "₹320 / m", sizes: ["Per metre"],
    description: "A refined, deep-toned georgette with couture drape for evening and occasion wear." },
  { id: "indigo-blossom-kurti", name: "Indigo Blossom Kurti Fabric", collection: "Kurti Fabrics",
    images: [IMG.kurtiGreen, IMG.kurtiMaroon, IMG.printedRack], material: "Cotton-blend",
    finish: "Breathable, soft", from: "₹190 / m", sizes: ["Per metre", "2.5m kurti cut"],
    description: "A breathable printed cotton-blend with intricate botanical motifs — an everyday kurti favourite." },
  { id: "marigold-kurti", name: "Marigold Ethnic Kurti Fabric", collection: "Kurti Fabrics",
    images: [IMG.kurtiRedStreet, IMG.kurtiRedGarden, IMG.printedFolds], material: "Rayon",
    finish: "Fluid, colour-fast", from: "₹210 / m", sizes: ["Per metre", "2.5m kurti cut"],
    description: "Warm, festive prints on soft rayon that hold vivid colour wash after wash." },
  { id: "jaipur-dress-material", name: "Jaipur Bagru Dress Material", collection: "Dress Materials",
    images: [IMG.printedStack, IMG.printedFolds, IMG.printedScarves], material: "Cotton (unstitched set)",
    finish: "Coordinated 3-piece", from: "₹1,150 / set", sizes: ["Top + Bottom + Dupatta"],
    description: "A coordinated unstitched dress-material set inspired by traditional Bagru block-print motifs." },
  { id: "aurora-dress-material", name: "Aurora Georgette Dress Material", collection: "Dress Materials",
    images: [IMG.printedRack, IMG.fashionGreen, IMG.printedFolds], material: "Georgette (unstitched set)",
    finish: "Coordinated 3-piece", from: "₹1,480 / set", sizes: ["Top + Bottom + Dupatta"],
    description: "A luminous, gradient-printed georgette set — modern, festive and ready to stitch." },
  { id: "grand-gala-event-drape", name: "Grand Gala Event Drape", collection: "Event Fabrics",
    images: [IMG.eventGala, IMG.eventStageGold, IMG.eventBlueStage], material: "Printed tension fabric",
    finish: "Seamless matte", from: "On request", sizes: ["Modular panels", "Custom"],
    description: "Large-format printed drapery and panels that turn a venue into an occasion." },
  { id: "onyx-velvet-backdrop", name: "Onyx Velvet Backdrop", collection: "Photography Backdrops",
    images: [IMG.studioBlack, IMG.studioLights, IMG.studioPink], material: "Cotton-blend velvet",
    finish: "Matte, non-reflective", from: "₹4,500", sizes: ["8 × 8 ft", "10 × 12 ft", "12 × 20 ft"],
    description: "A deep, light-absorbing velvet that renders skin tones beautifully — the studio essential." },
  { id: "imperial-mandap-backdrop", name: "Imperial Mandap Backdrop", collection: "Wedding Backdrops",
    images: [IMG.weddingArch, IMG.weddingCandles, IMG.weddingChandelier], material: "Layered sheer + satin",
    finish: "Ornate, embellished", from: "On request", sizes: ["Bespoke"],
    description: "A grand ceremonial backdrop layering sheers, satin and florals into an heirloom centrepiece." },
  { id: "celestial-stage-backdrop", name: "Celestial Stage Backdrop", collection: "Stage Backdrops",
    images: [IMG.eventStageGold, IMG.eventBlueStage, IMG.eventGala], material: "Seamless tension fabric",
    finish: "Wide-format, seamless", from: "On request", sizes: ["Any stage size"],
    description: "Seamless, wrinkle-free printed stage backdrops for concerts, conferences and productions." },
  { id: "bespoke-custom-print", name: "Bespoke Custom Print", collection: "Custom Printing",
    images: [IMG.printMachine, IMG.printMachine2, IMG.printedRack], material: "Your choice of base",
    finish: "As specified", from: "Quote", sizes: ["Any size"],
    description: "Bring your artwork — we colour-match, print, cut and stitch to your exact specification." },
];

export const TESTIMONIALS = [
  { quote: "The print clarity and colour on their georgette is unreal — my boutique's bestsellers now.", name: "Ananya Kapoor", role: "Boutique Owner, Jaipur" },
  { quote: "Nayara prints our label's entire kurti range. Consistent, vivid and always on time.", name: "Rhea Sharma", role: "Fashion Label Founder, Ahmedabad" },
  { quote: "Their seamless stage backdrops made our concert look world-class. Flawless finish.", name: "Karan Desai", role: "Event Producer, Mumbai" },
];

export const WHY = [
  { icon: "Sparkles", title: "Premium Digital Printing", text: "Designer-grade sublimation printing with razor-sharp detail and vivid, wash-fast colour." },
  { icon: "Factory", title: "In-house Manufacturing", text: "Printing, fusing, cutting and stitching — all under one accountable roof." },
  { icon: "Shirt", title: "Fashion & Event Specialists", text: "Deep expertise across apparel fabrics and large-format event & stage textiles." },
  { icon: "BadgeCheck", title: "High-Quality Printing", text: "Calibrated colour workflows deliver true-to-artwork results, every run." },
  { icon: "Ruler", title: "Custom Manufacturing", text: "Any fabric, any print, any finish — engineered precisely around your brief." },
  { icon: "Layers", title: "Bulk Production", text: "Scale from boutique cuts to large production runs without losing consistency." },
  { icon: "Zap", title: "Fast Turnaround", text: "Streamlined in-house stages mean quick, reliable delivery timelines." },
  { icon: "ShieldCheck", title: "Quality Checked", text: "Every order is inspected and finished before it earns the Nayara name." },
];

export const INDUSTRIES = [
  { icon: "Shirt", name: "Fashion Brands" },
  { icon: "Factory", name: "Garment Manufacturers" },
  { icon: "Store", name: "Boutiques" },
  { icon: "Package", name: "Textile Wholesalers" },
  { icon: "PartyPopper", name: "Event Companies" },
  { icon: "Heart", name: "Wedding Decorators" },
  { icon: "Camera", name: "Photography Studios" },
  { icon: "Megaphone", name: "Advertising Agencies" },
];

export const PROCESS = [
  { icon: "PenTool", title: "Artwork", text: "Your design is prepared and colour-calibrated for print." },
  { icon: "Printer", title: "Printing", text: "Artwork is printed onto sublimation transfer paper." },
  { icon: "Flame", title: "Heat Transfer (Fusing)", text: "Heat fuses the print permanently into the base fabric." },
  { icon: "Scissors", title: "Cutting", text: "Fabric is precision-cut to the exact specification." },
  { icon: "Package", title: "Bundle Packing", text: "Each order is inspected, folded and bundled with care." },
  { icon: "ShieldCheck", title: "Quality Inspection", text: "A final quality check ensures colour, finish and stitch meet our standard." },
  { icon: "Truck", title: "Dispatch", text: "Packed and shipped, ready to wear or hang." },
];

export const GALLERY = [
  IMG.printedFolds, IMG.kurtiRedStreet, IMG.fashionSheer, IMG.eventGala, IMG.weddingArch,
  IMG.printedRack, IMG.kurtiGreen, IMG.eventStageGold, IMG.studioBlack, IMG.weddingChandelier,
  IMG.fashionGreen, IMG.printedScarves, IMG.kurtiMaroon, IMG.fashionWhite, IMG.eventBlueStage,
];

export const findProduct = (id) => PRODUCTS.find((p) => p.id === id);
export const productsInCollection = (name) => PRODUCTS.filter((p) => p.collection === name);
export const findCollection = (slug) => COLLECTIONS.find((c) => c.slug === slug);
